
import BanksList from '~/components/calc-block/BanksList.vue';
import CalcBlockControls from '~/components/calc-block/CalcBlockControls.vue'

export default {
  name: 'CalcOfIpoteka',

  props: {
    // Для cms блока и страницы товара
    extras: {
      type: Object,
      default: () => ({}),
    },
    // Для страницы продукта
    productPrice: {
      type: Number,
      default: null,
      required: false,
    }
  },

  data() {
    return {
      tabsList: [],
      banksList: [],
      livePrograms: [],
      isCalcLoading: false,
      calcReady: false,
      currentTab: {
        id: null,
      },
      initPaymentInfo: {
        cost: [],
        term: [],
        interestRate: [],
        firstPay: [],
      },
      currentPaymentInfo: {
        cost: undefined,
        term: undefined,
        interestRate: undefined,
        firstPay: undefined,
      },
    }
  },

  components: {
    BanksList,
    CalcBlockControls,
  },

  computed: {
    programsList() {
      return Array.isArray(this.extras.programs) ? this.extras.programs : [];
    },
    extrasProgram() {
      return this.programsList.find((t) => t.id === this.currentTab.id);
    },
    getFirstPayDiapazon: function() {
      const programList = this.extrasProgram?.items || [];

      const firstPayList = [];
      const cost = this.currentPaymentInfo.cost || 0;

      programList.forEach((bank) => {
        firstPayList.push(bank.firstPay);
      });

      const firstPay = firstPayList.length ? Math.min.apply(null, firstPayList) : 0;

      const min = Number(Math.round(cost / 100 * firstPay));
      const max = cost;

      return { min, max }
    },
    calcSignature() {
      return [
        this.currentPaymentInfo.cost,
        this.currentPaymentInfo.firstPay,
        this.currentPaymentInfo.term,
      ].join('|');
    },
  },

  methods: {
    matchLiveProgram() {
      const extras = this.extrasProgram;
      return this.livePrograms.find((program) => (
        (extras && (String(program.id) === String(extras.id) || program.name === extras.name))
        || program.name === this.currentTab.name
        || String(program.id) === String(this.currentTab.id)
      ));
    },

    applyBanksList() {
      const live = this.matchLiveProgram();
      this.banksList = live?.items?.length ? live.items : [];
    },

    clampToRange(value, min, max, fallback) {
      const next = value == null || Number.isNaN(Number(value)) ? fallback : Number(value);
      return Math.min(max, Math.max(min, next));
    },

    applySliderBounds(isInitial) {
      const initProgram = this.extrasProgram;
      if (!initProgram?.items?.length) {
        this.applyBanksList();
        return;
      }

      const costList = new Set();
      const termList = new Set();
      const interestRateList = new Set();

      initProgram.items.forEach((t) => {
        costList.add(t.minCost);
        costList.add(t.maxCost);

        termList.add(t.minTerm);
        termList.add(t.maxTerm);

        interestRateList.add(t.interestRate);
      });

      const costs = Array.from(costList);
      const terms = Array.from(termList);
      const rates = Array.from(interestRateList);
      const costMin = Math.min.apply(null, costs);
      const costMax = Math.max.apply(null, costs);
      const termMin = Math.min.apply(null, terms);
      const termMax = Math.max.apply(null, terms);
      const rateMin = Math.min.apply(null, rates);
      const rateMax = Math.max.apply(null, rates);

      this.initPaymentInfo.cost = costs;
      this.initPaymentInfo.term = terms;
      this.initPaymentInfo.interestRate = rates;

      if (isInitial) {
        this.currentPaymentInfo.cost = this.productPrice || 5000000;
        this.currentPaymentInfo.term = termMax;
        this.currentPaymentInfo.interestRate = rateMin;
      }

      this.currentPaymentInfo.cost = this.clampToRange(this.currentPaymentInfo.cost, costMin, costMax, 5000000);
      this.currentPaymentInfo.term = this.clampToRange(this.currentPaymentInfo.term, termMin, termMax, termMax);
      this.currentPaymentInfo.interestRate = this.clampToRange(
        this.currentPaymentInfo.interestRate,
        rateMin,
        rateMax,
        rateMin
      );

      const firstPayRange = this.getFirstPayDiapazon;
      this.initPaymentInfo.firstPay = [firstPayRange.min, firstPayRange.max];
      if (isInitial) {
        this.currentPaymentInfo.firstPay = firstPayRange.min;
      }
      this.currentPaymentInfo.firstPay = this.clampToRange(
        this.currentPaymentInfo.firstPay,
        firstPayRange.min,
        firstPayRange.max,
        firstPayRange.min
      );
      this.applyBanksList();
    },

    isStaleCalcError(err) {
      const error = err || {};
      return error.name === 'CanceledError'
        || error.name === 'AbortError'
        || error.code === 'ERR_CANCELED';
    },

    async fetchCalcOffers() {
      const cost = this.currentPaymentInfo.cost;
      const firstPay = this.currentPaymentInfo.firstPay;
      const term = this.currentPaymentInfo.term;
      if (!cost || term == null || firstPay == null) {
        return;
      }

      const requestId = ++this._calcRequestId;
      this.isCalcLoading = true;

      try {
        const res = await this.$api.agent.transport.post('/banks/calc-offers', { cost, firstPay, term });
        if (requestId !== this._calcRequestId) {
          return;
        }
        const payload = res.data;
        this.livePrograms = payload?.programs || [];
        this.applyBanksList();
      } catch (err) {
        if (this.isStaleCalcError(err) || requestId !== this._calcRequestId) {
          return;
        }
        console.log('calc-offers error:', err);
      } finally {
        if (requestId === this._calcRequestId) {
          this.isCalcLoading = false;
        }
      }
    },

    scheduleCalcOffers(immediate = false) {
      if (this._calcDebounce) {
        clearTimeout(this._calcDebounce);
        this._calcDebounce = null;
      }
      if (immediate) {
        this.fetchCalcOffers();
        return;
      }
      this._calcDebounce = setTimeout(() => {
        this.fetchCalcOffers();
      }, 400);
    },

    onChangeCurrentTab(tab) {
      const prevCost = this.currentPaymentInfo.cost;
      const prevFirstPay = this.currentPaymentInfo.firstPay;
      const prevTerm = this.currentPaymentInfo.term;

      this._ignoreCalcWatch = true;
      this.currentTab = tab;
      this.applySliderBounds(false);

      const slidersChanged = (
        this.currentPaymentInfo.cost !== prevCost
        || this.currentPaymentInfo.firstPay !== prevFirstPay
        || this.currentPaymentInfo.term !== prevTerm
      );
      if (slidersChanged) {
        this.scheduleCalcOffers(true);
      }
      this.$nextTick(() => {
        this._ignoreCalcWatch = false;
      });
    },

    onChangeCurrentPaymentInfo(opt) {
      this.currentPaymentInfo[opt.slug] = opt.value;
    },

    onUpdateBank(item) {
      const replace = (list) => list.map((bank) => {
        if (item.sdelkaHash && bank.sdelkaHash === item.sdelkaHash) {
          return item;
        }
        if (bank.id === item.id) {
          return item;
        }
        return bank;
      });
      this.banksList = replace(this.banksList || []);
      this.livePrograms = this.livePrograms.map((program) => ({
        ...program,
        items: replace(program.items || []),
      }));
    },
  },

  watch: {
    'currentPaymentInfo.cost': function () {
      const firstPayRange = this.getFirstPayDiapazon;
      this.initPaymentInfo.firstPay = [firstPayRange.min, firstPayRange.max];
      this.currentPaymentInfo.firstPay = this.clampToRange(
        this.currentPaymentInfo.firstPay,
        firstPayRange.min,
        firstPayRange.max,
        firstPayRange.min
      );
    },
    calcSignature: function () {
      if (!this.calcReady || this._ignoreCalcWatch) {
        return;
      }
      this.scheduleCalcOffers();
    },
  },

  mounted: function() {
    this._calcDebounce = null;
    this._ignoreCalcWatch = false;
    this._calcRequestId = 0;

    this.programsList.forEach((t) => {
      if (t.items && t.items.length) {
        this.tabsList.push({
          name: t.name,
          id: t.id
        });
      }
    });

    const initProgram = this.programsList[0];
    this.currentTab = { id: initProgram?.id, name: initProgram?.name };

    this._ignoreCalcWatch = true;
    this.applySliderBounds(true);
    this.calcReady = true;
    this.scheduleCalcOffers(true);
    this.$nextTick(() => {
      this._ignoreCalcWatch = false;
    });
  },

  beforeDestroy: function() {
    if (this._calcDebounce) {
      clearTimeout(this._calcDebounce);
    }
  },
}

